(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["floorsupply-area-calculator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('floor-area-calculator')) {
  class FloorAreaCalculator extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.mode = this.dataset.mode || 'fixed-pack';
      this.areaInput = this.querySelector('[data-floor-area-input]');
      this.wasteInput = this.querySelector('[data-floor-waste]');
      this.result = this.querySelector('[data-floor-result]');
      this.packsOutput = this.querySelector('[data-floor-packs]');
      this.coverageOutput = this.querySelector('[data-floor-coverage]');
      this.requiredOutput = this.querySelector('[data-floor-required]');
      this.marginOutput = this.querySelector('[data-floor-margin]');
      this.totalOutput = this.querySelector('[data-floor-total]');
      this.messageOutput = this.querySelector('[data-floor-message]');

      this.wastePercent = Math.max(0, this.toNumber(this.dataset.wastePercent) || 0);
      this.packArea = this.toNumber(this.dataset.packArea);
      this.packPriceCents = Math.max(0, Math.round(this.toNumber(this.dataset.packPrice)));
      this.unitPriceCents = Math.max(0, Math.round(this.toNumber(this.dataset.unitPrice)));
      this.currency = this.dataset.currency || 'EUR';
      this.minPacks = Math.max(1, Math.round(this.toNumber(this.dataset.minPacks) || 1));
      this.increment = Math.max(1, Math.round(this.toNumber(this.dataset.increment) || 1));
      this.maxPacks = this.dataset.maxPacks
        ? Math.max(this.minPacks, Math.round(this.toNumber(this.dataset.maxPacks)))
        : null;

      this.messages = {
        invalid: this.dataset.messageInvalid,
        variableWithWaste: this.dataset.messageVariableWithWaste,
        variableWithoutWaste: this.dataset.messageVariableWithoutWaste,
        tooLarge: this.dataset.messageTooLarge,
        fixedWithWaste: this.dataset.messageFixedWithWaste,
        fixedWithoutWaste: this.dataset.messageFixedWithoutWaste,
        manual: this.dataset.messageManual,
        onRequest: this.dataset.onRequest,
      };

      this.areaFormatter = new Intl.NumberFormat(this.dataset.locale || document.documentElement.lang || 'nl-BE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 3,
      });
      this.moneyFormatter = new Intl.NumberFormat(this.dataset.locale || document.documentElement.lang || 'nl-BE', {
        style: 'currency',
        currency: this.currency,
      });

      if (!this.areaInput || !this.wasteInput || !this.result) {
        this.hidden = true;
        return;
      }

      if (this.mode === 'fixed-pack' && (!Number.isFinite(this.packArea) || this.packArea <= 0)) {
        this.hidden = true;
        return;
      }

      this.areaInput.addEventListener('input', () => this.calculate());
      this.areaInput.addEventListener('blur', () => this.normalizeAreaInput());
      this.wasteInput.addEventListener('change', () => this.calculate());

      if (this.mode === 'fixed-pack') {
        queueMicrotask(() => this.bindQuantityInput());
        setTimeout(() => this.bindQuantityInput(), 0);
      }
    }

    toNumber(value) {
      if (typeof value === 'number') return value;
      return Number(String(value || '').trim().replace(',', '.'));
    }

    bindQuantityInput() {
      if (this.mode !== 'fixed-pack' || this.quantityInput) return;
      const form = this.closest('form');
      if (!form) return;

      this.quantityInput = form.querySelector('input[name="quantity"]');
      if (!this.quantityInput) return;

      this.quantityInput.addEventListener('change', () => this.renderFromQuantity());
      this.quantityInput.addEventListener('input', () => {
        if (!this.settingQuantity) this.renderFromQuantity();
      });

      this.renderFixed(this.roundToAllowedPacks(this.toNumber(this.quantityInput.value) || this.minPacks));

      form.addEventListener('click', (event) => {
        if (event.target.closest('.quantity-plus, .quantity-minus')) {
          setTimeout(() => this.renderFromQuantity(), 50);
        }
      });
    }

    normalizeAreaInput() {
      const area = this.toNumber(this.areaInput.value);
      if (!Number.isFinite(area) || area <= 0) return;
      this.areaInput.value = String(area).replace('.', ',');
    }

    roundToAllowedPacks(rawPacks) {
      const nearestInteger = Math.round(rawPacks);
      const tolerance = Number.EPSILON * Math.max(1, Math.abs(rawPacks)) * 8;
      const normalizedPacks = Math.abs(rawPacks - nearestInteger) <= tolerance ? nearestInteger : rawPacks;
      let packs = Math.max(this.minPacks, Math.ceil(normalizedPacks));
      if (this.increment > 1) {
        const steps = Math.ceil((packs - this.minPacks) / this.increment);
        packs = this.minPacks + Math.max(0, steps) * this.increment;
      }
      if (this.maxPacks !== null) packs = Math.min(packs, this.maxPacks);
      return packs;
    }

    calculate() {
      const enteredArea = this.toNumber(this.areaInput.value);

      if (!Number.isFinite(enteredArea) || enteredArea <= 0) {
        if (this.mode === 'fixed-pack' && this.quantityInput) {
          this.renderFixed(this.roundToAllowedPacks(this.toNumber(this.quantityInput.value) || this.minPacks));
        } else {
          this.result.hidden = true;
        }
        this.messageOutput.textContent = this.messages.invalid;
        return;
      }

      const useWaste = this.wasteInput.checked;
      const requiredArea = enteredArea * (useWaste ? 1 + this.wastePercent / 100 : 1);

      if (this.mode === 'variable-area') {
        this.renderVariable(requiredArea, useWaste);
        this.messageOutput.textContent = useWaste
          ? this.messages.variableWithWaste
          : this.messages.variableWithoutWaste;
        return;
      }

      this.bindQuantityInput();
      const packs = this.roundToAllowedPacks(requiredArea / this.packArea);

      if (this.maxPacks !== null && packs * this.packArea < requiredArea) {
        this.messageOutput.textContent = this.messages.tooLarge;
      } else if (useWaste) {
        this.messageOutput.textContent = this.messages.fixedWithWaste.replace(
          '__AREA__',
          this.areaFormatter.format(requiredArea),
        );
      } else {
        this.messageOutput.textContent = this.messages.fixedWithoutWaste;
      }

      this.setQuantity(packs);
      this.renderFixed(packs);
    }

    setQuantity(packs) {
      if (!this.quantityInput) return;
      this.settingQuantity = true;
      this.quantityInput.value = String(packs);
      this.quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      this.settingQuantity = false;
    }

    renderFromQuantity() {
      if (this.settingQuantity) return;
      if (this.mode !== 'fixed-pack' || !this.quantityInput || this.result.hidden) return;
      const packs = Math.max(1, Math.round(this.toNumber(this.quantityInput.value) || 1));
      this.renderFixed(packs);
      this.messageOutput.textContent = this.messages.manual;
    }

    renderFixed(packs) {
      const coverage = packs * this.packArea;
      const total = packs * (this.packPriceCents / 100);

      if (this.packsOutput) this.packsOutput.textContent = String(packs);
      if (this.coverageOutput) this.coverageOutput.textContent = `${this.areaFormatter.format(coverage)} m²`;
      if (this.totalOutput) this.totalOutput.textContent = this.moneyFormatter.format(total);
      this.result.hidden = false;
    }

    renderVariable(requiredArea, useWaste) {
      const total = requiredArea * (this.unitPriceCents / 100);

      if (this.requiredOutput) this.requiredOutput.textContent = `${this.areaFormatter.format(requiredArea)} m²`;
      if (this.marginOutput) this.marginOutput.textContent = useWaste ? `+${this.wastePercent}%` : '0%';
      if (this.totalOutput) {
        this.totalOutput.textContent =
          this.unitPriceCents > 0 ? this.moneyFormatter.format(total) : this.messages.onRequest;
      }
      this.result.hidden = false;
    }
  }

  customElements.define('floor-area-calculator', FloorAreaCalculator);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["floorsupply-unit-sort"] && !Shopify.designMode) return;
  try {
    const floorsupplySortCache = new Map();

  function floorsupplyComparePrices(a, b, descending) {
    const aKnown = Number.isFinite(a.price);
    const bKnown = Number.isFinite(b.price);
    if (aKnown !== bKnown) return aKnown ? -1 : 1;
    if (aKnown && a.price !== b.price) return descending ? b.price - a.price : a.price - b.price;
    return a.index - b.index;
  }

  class FloorSupplyUnitSort extends HTMLElement {
    static observedAttributes = ['data-sort-by', 'data-filter-key', 'data-current-page', 'data-total'];

    connectedCallback() {
      this.scheduleSort();
      this.querySelector('[data-sort-retry]')?.addEventListener('click', () => this.sortCollection(true));
    }

    disconnectedCallback() {
      clearTimeout(this.scheduled);
      this.controller?.abort();
      this.version = (this.version || 0) + 1;
    }

    attributeChangedCallback() {
      if (this.isConnected) this.scheduleSort();
    }

    scheduleSort() {
      clearTimeout(this.scheduled);
      this.scheduled = setTimeout(() => this.sortCollection(), 0);
    }

    setStatus(state) {
      this.dataset.state = state;
      this.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
      const status = this.querySelector('[data-sort-status]');
      if (!status) return;
      status.querySelector('[data-loading-text]').hidden = state !== 'loading';
      status.querySelector('[data-ready-text]').hidden = state !== 'ready';
      status.querySelector('[data-error-text]').hidden = state !== 'error';
      status.querySelector('[data-sort-retry]').hidden = state !== 'error';
    }

    extractCards(root) {
      const grid = root.querySelector('[ref="grid"]');
      if (!grid) return [];
      return [...grid.querySelectorAll(':scope > [data-product-id]')].map(card => {
        const raw = card.dataset.floorsupplySortPrice;
        return {
          id: card.dataset.productId,
          price: raw?.trim() ? Number(raw) : NaN,
          html: card.outerHTML,
        };
      });
    }

    async sortCollection(force = false) {
      if (!this.isConnected) return;
      this.controller?.abort();
      this.controller = new AbortController();
      const controller = this.controller;
      const version = this.version = (this.version || 0) + 1;
      const grid = this.querySelector('[ref="grid"]');
      if (!grid) {
        this.setStatus('ready');
        return;
      }
      const page = Number(this.dataset.currentPage);
      const pages = Number(this.dataset.pages);
      const pageSize = Number(this.dataset.pageSize);
      const total = Number(this.dataset.total);
      const requestUrl = new URL(window.location.href);
      requestUrl.hash = '';
      requestUrl.searchParams.delete('page');
      requestUrl.searchParams.delete('sections');
      requestUrl.searchParams.set('section_id', this.dataset.sectionId);
      requestUrl.searchParams.set('sort_by', this.dataset.sortBy);
      const key = requestUrl.toString() + '|' + this.dataset.filterKey + '|' + total + '|' + pageSize;
      this.setStatus('loading');
      const timeout = setTimeout(() => controller.abort(), 45000);
      try {
        if (!Number.isInteger(page) || !Number.isInteger(pages) || !Number.isInteger(pageSize) || page < 1 || pages < 1 || page > pages || pageSize < 1) throw new Error('Invalid pagination');
        let cards;
        const cached = floorsupplySortCache.get(key);
        if (!force && cached && Date.now() - cached.time < 60000) {
          cards = cached.cards;
        } else {
          const batches = new Map();
          if (this.dataset.stateBeforeSort !== 'ready') batches.set(page, this.extractCards(this));
          const queue = Array.from({ length: pages }, (_, i) => i + 1).filter(n => !batches.has(n));
          const worker = async () => {
            while (queue.length) {
              const requestedPage = queue.shift();
              const url = new URL(requestUrl);
              url.searchParams.set('page', String(requestedPage));
              const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
              if (!response.ok) throw new Error('Collection request failed');
              const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
              const source = doc.querySelector('floorsupply-unit-sort');
              if (!source || source.dataset.sectionId !== this.dataset.sectionId || source.dataset.sortBy !== this.dataset.sortBy || source.dataset.filterKey !== this.dataset.filterKey || Number(source.dataset.currentPage) !== requestedPage || Number(source.dataset.total) !== total || Number(source.dataset.pages) !== pages) throw new Error('Collection response mismatch');
              batches.set(requestedPage, this.extractCards(source));
            }
          };
          await Promise.all(Array.from({ length: Math.min(3, queue.length) }, worker));
          cards = [...batches.entries()].sort((a, b) => a[0] - b[0]).flatMap(([, batch]) => batch);
          if (cards.length !== total || new Set(cards.map(card => card.id)).size !== total) throw new Error('Incomplete collection');
          cards = cards.map((card, index) => ({ ...card, index }));
          floorsupplySortCache.set(key, { cards, time: Date.now() });
          while (floorsupplySortCache.size > 5) floorsupplySortCache.delete(floorsupplySortCache.keys().next().value);
        }
        if (!this.isConnected || this.version !== version) return;
        const descending = this.dataset.sortBy === 'price-descending';
        const ordered = [...cards].sort((a, b) => floorsupplyComparePrices(a, b, descending));
        const visible = ordered.slice((page - 1) * pageSize, page * pageSize);
        const fragment = document.createDocumentFragment();
        visible.forEach((card, index) => {
          const template = document.createElement('template');
          template.innerHTML = card.html;
          const item = template.content.firstElementChild;
          item.dataset.page = String(page);
          item.className = item.className.replace(/product-grid__item--\d+\b/g, 'product-grid__item--' + index);
          fragment.append(item);
        });
        grid.querySelectorAll(':scope > [data-product-id]').forEach(card => card.remove());
        grid.append(fragment);
        this.dataset.stateBeforeSort = 'ready';
        this.setStatus('ready');
      } catch (error) {
        controller.abort();
        if (this.isConnected && this.version === version) this.setStatus('error');
      } finally {
        clearTimeout(timeout);
      }
    }
  }

  if (!customElements.get('floorsupply-unit-sort')) {
    customElements.define('floorsupply-unit-sort', FloorSupplyUnitSort);
  }
  } catch(e) { console.error(e); }
})();

})();
